var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "album-stat-v3" },
    [
      _c("div", { staticClass: "stat-section-header" }, [
        _vm._m(0),
        _vm.overview
          ? _c("div", { staticClass: "header-badge-group" }, [
              _c("span", { staticClass: "live-indicator" }, [
                _c("span", { staticClass: "pulse-dot" }),
                _vm._v(
                  "\n        Tổng album: " +
                    _vm._s(_vm.overview.totalAlbums) +
                    " • Đã duyệt: " +
                    _vm._s(_vm.overview.approvedAlbums) +
                    " (" +
                    _vm._s(_vm.overview.approvalRate) +
                    "%)\n      "
                ),
              ]),
            ])
          : _vm._e(),
      ]),
      _c("div", { staticClass: "filter-control-bar" }, [
        _c("div", { staticClass: "filter-left" }, [
          _c("div", { staticClass: "filter-mode-pills" }, [
            _c(
              "button",
              {
                class: ["mode-pill-btn", { active: _vm.filterMode === "DAY" }],
                on: {
                  click: function ($event) {
                    return _vm.changeFilterMode("DAY")
                  },
                },
              },
              [_c("i", { staticClass: "el-icon-date" }), _vm._v(" Theo ngày")]
            ),
            _c(
              "button",
              {
                class: ["mode-pill-btn", { active: _vm.filterMode === "WEEK" }],
                on: {
                  click: function ($event) {
                    return _vm.changeFilterMode("WEEK")
                  },
                },
              },
              [_c("i", { staticClass: "el-icon-time" }), _vm._v(" Theo tuần")]
            ),
            _c(
              "button",
              {
                class: [
                  "mode-pill-btn",
                  { active: _vm.filterMode === "RANGE" },
                ],
                on: {
                  click: function ($event) {
                    return _vm.changeFilterMode("RANGE")
                  },
                },
              },
              [
                _c("i", { staticClass: "el-icon-calendar" }),
                _vm._v(" Khoảng thời gian"),
              ]
            ),
          ]),
          _vm.filterMode === "DAY"
            ? _c(
                "div",
                { staticClass: "filter-chip" },
                [
                  _c("el-date-picker", {
                    staticClass: "filter-date-input",
                    attrs: {
                      type: "date",
                      size: "small",
                      format: "dd/MM/yyyy",
                      "value-format": "yyyy-MM-dd",
                      clearable: false,
                      "picker-options": _vm.pickerOptions,
                    },
                    on: { change: _vm.refreshData },
                    model: {
                      value: _vm.selectedDate,
                      callback: function ($$v) {
                        _vm.selectedDate = $$v
                      },
                      expression: "selectedDate",
                    },
                  }),
                ],
                1
              )
            : _vm.filterMode === "WEEK"
            ? _c(
                "div",
                { staticClass: "filter-week-group" },
                [
                  _c("el-date-picker", {
                    staticClass: "filter-week-input",
                    attrs: {
                      type: "week",
                      size: "small",
                      format: "Tuần WW (yyyy)",
                      clearable: false,
                      "picker-options": _vm.pickerOptions,
                    },
                    on: { change: _vm.refreshData },
                    model: {
                      value: _vm.selectedWeekDate,
                      callback: function ($$v) {
                        _vm.selectedWeekDate = $$v
                      },
                      expression: "selectedWeekDate",
                    },
                  }),
                  _c("div", { staticClass: "week-nav-btn-group" }, [
                    _c(
                      "button",
                      {
                        staticClass: "nav-arrow-btn",
                        attrs: { title: "Tuần trước" },
                        on: {
                          click: function ($event) {
                            return _vm.moveWeek(-1)
                          },
                        },
                      },
                      [_c("i", { staticClass: "el-icon-arrow-left" })]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "nav-current-btn",
                        on: { click: _vm.currentWeek },
                      },
                      [_vm._v("Tuần này")]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "nav-arrow-btn",
                        attrs: {
                          title: "Tuần sau",
                          disabled: !_vm.canMoveNextWeek,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.moveWeek(1)
                          },
                        },
                      },
                      [_c("i", { staticClass: "el-icon-arrow-right" })]
                    ),
                  ]),
                  _c("span", { staticClass: "range-display-tag" }, [
                    _vm._v(_vm._s(_vm.weekRangeLabel)),
                  ]),
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "filter-chip" },
                [
                  _c("el-date-picker", {
                    staticClass: "filter-range-input",
                    attrs: {
                      type: "daterange",
                      size: "small",
                      "range-separator": "đến",
                      "start-placeholder": "Từ ngày",
                      "end-placeholder": "Đến ngày",
                      format: "dd/MM/yyyy",
                      "value-format": "yyyy-MM-dd",
                      clearable: false,
                      "picker-options": _vm.pickerOptions,
                    },
                    on: { change: _vm.refreshData },
                    model: {
                      value: _vm.selectedDateRange,
                      callback: function ($$v) {
                        _vm.selectedDateRange = $$v
                      },
                      expression: "selectedDateRange",
                    },
                  }),
                ],
                1
              ),
          _c(
            "div",
            { staticClass: "filter-chip" },
            [
              _vm._m(1),
              _c(
                "el-select",
                {
                  staticClass: "grade-select",
                  attrs: { size: "small" },
                  on: { change: _vm.refreshData },
                  model: {
                    value: _vm.selectedGrade,
                    callback: function ($$v) {
                      _vm.selectedGrade = $$v
                    },
                    expression: "selectedGrade",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "Tất cả các khối", value: null },
                  }),
                  _vm._l(_vm.gradeOptions, function (grade) {
                    return _c("el-option", {
                      key: grade.gradeId,
                      attrs: { label: grade.gradeName, value: grade.gradeId },
                    })
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "filter-right" },
          [
            _c(
              "el-button",
              {
                staticClass: "btn-refresh",
                attrs: {
                  type: "primary",
                  size: "small",
                  icon: "el-icon-refresh-right",
                  loading: _vm.loadingOverview,
                },
                on: { click: _vm.refreshData },
              },
              [_vm._v("Làm mới")]
            ),
          ],
          1
        ),
      ]),
      _vm.apiError
        ? _c("el-alert", {
            staticClass: "stat-api-error",
            attrs: {
              title: _vm.apiError,
              type: "error",
              closable: false,
              "show-icon": "",
            },
          })
        : _vm._e(),
      _vm.loadingOverview
        ? _c("div", { staticClass: "album-loading-state" }, [
            _vm._v("Đang tải thống kê album..."),
          ])
        : !_vm.overview && !_vm.apiError
        ? _c("div", { staticClass: "album-loading-state" }, [
            _vm._v("Chưa có dữ liệu thống kê album."),
          ])
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "album-kpi-grid",
          class: { "album-stat-disabled": !_vm.overview },
        },
        [
          _c(
            "div",
            {
              staticClass: "album-kpi-card border-purple interactive-card",
              on: {
                click: function ($event) {
                  return _vm.openDialog("ALL")
                },
              },
            },
            [
              _vm._m(2),
              _c("div", { staticClass: "kpi-details" }, [
                _vm._m(3),
                _c("div", { staticClass: "kpi-number text-purple" }, [
                  _vm._v(_vm._s(_vm.metric("totalAlbums")) + " "),
                  _c("span", { staticClass: "kpi-unit" }, [_vm._v("album")]),
                ]),
                _c("div", { staticClass: "kpi-hint" }, [
                  _vm._v(
                    "Đã đăng từ " +
                      _vm._s(_vm.metric("publishingClasses")) +
                      " lớp học"
                  ),
                ]),
              ]),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "album-kpi-card border-emerald interactive-card",
              on: {
                click: function ($event) {
                  return _vm.openDialog("APPROVED")
                },
              },
            },
            [
              _vm._m(4),
              _c("div", { staticClass: "kpi-details" }, [
                _vm._m(5),
                _c("div", { staticClass: "kpi-number text-emerald" }, [
                  _vm._v(_vm._s(_vm.metric("approvedAlbums")) + " "),
                  _c("span", { staticClass: "kpi-unit" }, [_vm._v("album")]),
                ]),
                _c("div", { staticClass: "kpi-hint text-emerald" }, [
                  _vm._v(
                    "Đạt " +
                      _vm._s(_vm.metric("approvalRate")) +
                      "% tổng số album"
                  ),
                ]),
              ]),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "album-kpi-card border-amber interactive-card",
              on: {
                click: function ($event) {
                  return _vm.openDialog("PENDING")
                },
              },
            },
            [
              _vm._m(6),
              _c("div", { staticClass: "kpi-details" }, [
                _vm._m(7),
                _c("div", { staticClass: "kpi-number text-amber" }, [
                  _vm._v(_vm._s(_vm.metric("pendingAlbums")) + " "),
                  _c("span", { staticClass: "kpi-unit" }, [_vm._v("album")]),
                ]),
                _c("div", { staticClass: "kpi-hint text-amber" }, [
                  _vm._v("Cần duyệt để phụ huynh xem"),
                ]),
              ]),
            ]
          ),
        ]
      ),
      _c(
        "el-row",
        { staticClass: "charts-row", attrs: { gutter: 20 } },
        [
          _c("el-col", { attrs: { xs: 24, sm: 24, md: 15, lg: 16 } }, [
            _c("div", { staticClass: "chart-card h-100" }, [
              _c("div", { staticClass: "chart-card-head" }, [
                _c("div", [
                  _c("h3", { staticClass: "chart-title" }, [
                    _vm._v("Số Lượng Album Của Từng Lớp Đã Đăng & Đã Duyệt"),
                  ]),
                  _c("p", { staticClass: "chart-subtitle" }, [
                    _vm._v(
                      "Một album gắn nhiều lớp được tính ở từng lớp liên quan"
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "chart-legend-chips" }, [
                  _c("span", { staticClass: "legend-dot-item" }, [
                    _c("span", { staticClass: "chip-color chip-approved" }),
                    _vm._v(" Đã được duyệt"),
                  ]),
                  _c("span", { staticClass: "legend-dot-item" }, [
                    _c("span", { staticClass: "chip-color chip-pending" }),
                    _vm._v(" Chờ duyệt"),
                  ]),
                ]),
              ]),
              _c("div", {
                ref: "chartClassAlbums",
                staticClass: "chart-box-main",
              }),
            ]),
          ]),
          _c("el-col", { attrs: { xs: 24, sm: 24, md: 9, lg: 8 } }, [
            _c("div", { staticClass: "chart-card h-100 doughnut-card" }, [
              _c("div", { staticClass: "chart-card-head" }, [
                _c("div", [
                  _c("h3", { staticClass: "chart-title" }, [
                    _vm._v("Phân Bổ Album Theo Khối"),
                  ]),
                  _c("p", { staticClass: "chart-subtitle" }, [
                    _vm._v("Mỗi album nằm ở một nhóm phân bổ"),
                  ]),
                ]),
                _c("span", { staticClass: "badge-total-pill" }, [
                  _vm._v(_vm._s(_vm.metric("totalAlbums")) + " Album"),
                ]),
              ]),
              _c("div", {
                ref: "chartGradeAlbums",
                staticClass: "chart-box-doughnut",
              }),
              _c(
                "div",
                { staticClass: "grade-legend-list" },
                _vm._l(_vm.displayedDistribution, function (item) {
                  return _c(
                    "div",
                    { key: item.key, staticClass: "grade-legend-row" },
                    [
                      _c("div", { staticClass: "legend-left" }, [
                        _c("span", {
                          staticClass: "color-dot",
                          style: { backgroundColor: _vm.colorFor(item) },
                        }),
                        _c("span", { staticClass: "legend-name" }, [
                          _vm._v(_vm._s(item.name)),
                        ]),
                      ]),
                      _c("div", { staticClass: "legend-right" }, [
                        _c("strong", { staticClass: "legend-count" }, [
                          _vm._v(_vm._s(item.albums) + " album"),
                        ]),
                        _c("span", { staticClass: "legend-pct" }, [
                          _vm._v("(" + _vm._s(item.percentage) + "%)"),
                        ]),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            width: "68%",
            top: "6vh",
            "custom-class": "modern-album-dialog",
            "destroy-on-close": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.closeDialog,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "dialog-custom-header",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c("div", { staticClass: "dialog-icon-badge" }, [
                _c("i", { staticClass: "el-icon-picture" }),
              ]),
              _c("div", [
                _c("h3", { staticClass: "dialog-heading" }, [
                  _vm._v(_vm._s(_vm.dialogTitle)),
                ]),
                _c("p", { staticClass: "dialog-subheading" }, [
                  _vm._v(_vm._s(_vm.activeFilterDesc)),
                ]),
              ]),
            ]
          ),
          _c("div", { staticClass: "dialog-filter-bar" }, [
            _c("div", { staticClass: "dialog-tab-group" }, [
              _c(
                "button",
                {
                  class: ["d-tab-btn", { active: _vm.dialogTab === "ALL" }],
                  on: {
                    click: function ($event) {
                      return _vm.changeDialogTab("ALL")
                    },
                  },
                },
                [_vm._v("Tất cả")]
              ),
              _c(
                "button",
                {
                  class: [
                    "d-tab-btn",
                    "tab-success",
                    { active: _vm.dialogTab === "APPROVED" },
                  ],
                  on: {
                    click: function ($event) {
                      return _vm.changeDialogTab("APPROVED")
                    },
                  },
                },
                [_vm._v("Đã duyệt")]
              ),
              _c(
                "button",
                {
                  class: [
                    "d-tab-btn",
                    "tab-warning",
                    { active: _vm.dialogTab === "PENDING" },
                  ],
                  on: {
                    click: function ($event) {
                      return _vm.changeDialogTab("PENDING")
                    },
                  },
                },
                [_vm._v("Chờ duyệt")]
              ),
            ]),
            _c(
              "div",
              { staticClass: "dialog-search" },
              [
                _c("el-input", {
                  attrs: {
                    size: "small",
                    placeholder: "Tìm tên album, lớp, người đăng...",
                    "prefix-icon": "el-icon-search",
                    clearable: "",
                  },
                  on: { input: _vm.scheduleDetailSearch },
                  model: {
                    value: _vm.dialogSearch,
                    callback: function ($$v) {
                      _vm.dialogSearch = $$v
                    },
                    expression: "dialogSearch",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm.dialogError
            ? _c("el-alert", {
                attrs: {
                  title: _vm.dialogError,
                  type: "error",
                  closable: false,
                  "show-icon": "",
                },
              })
            : _vm._e(),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingDialog,
                  expression: "loadingDialog",
                },
              ],
              staticClass: "dialog-album-grid-container",
            },
            [
              !_vm.loadingDialog && _vm.detailItems.length === 0
                ? _c("div", { staticClass: "empty-album-state" }, [
                    _c("i", { staticClass: "el-icon-picture-outline" }),
                    _c("p", [_vm._v("Không có album trong danh sách này")]),
                  ])
                : _vm._e(),
              _vm._l(_vm.detailItems, function (album) {
                return _c(
                  "div",
                  { key: album.idx, staticClass: "album-card-item" },
                  [
                    _c("div", { staticClass: "album-thumb-container" }, [
                      album.displayCoverUrl
                        ? _c("img", {
                            staticClass: "album-stat-cover",
                            attrs: {
                              src: album.displayCoverUrl,
                              alt: album.name,
                            },
                            on: {
                              error: function ($event) {
                                return _vm.$set(album, "displayCoverUrl", null)
                              },
                            },
                          })
                        : _c(
                            "div",
                            { staticClass: "album-cover-placeholder" },
                            [
                              _c("i", {
                                staticClass: "el-icon-camera cover-icon",
                              }),
                            ]
                          ),
                      _c("span", { staticClass: "photo-pill-badge" }, [
                        _c("i", { staticClass: "el-icon-picture" }),
                        _vm._v(" " + _vm._s(album.photoCount) + " ảnh"),
                      ]),
                      _c(
                        "span",
                        {
                          staticClass: "status-pill-badge",
                          class: album.approved
                            ? "badge-approved"
                            : "badge-pending",
                        },
                        [
                          _vm._v(
                            _vm._s(album.approved ? "Đã duyệt" : "Chờ duyệt")
                          ),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "album-card-body" }, [
                      _c(
                        "h4",
                        {
                          staticClass: "album-item-title",
                          attrs: { title: album.name },
                        },
                        [_vm._v(_vm._s(album.name))]
                      ),
                      _c("div", { staticClass: "album-item-meta" }, [
                        _c("span", { staticClass: "album-item-class" }, [
                          _c("i", { staticClass: "el-icon-s-home" }),
                          _vm._v(
                            " " +
                              _vm._s(
                                album.classNames.join(", ") || "Chưa phân bổ"
                              )
                          ),
                        ]),
                        _c("span", { staticClass: "album-item-date" }, [
                          _c("i", { staticClass: "el-icon-date" }),
                          _vm._v(
                            " " + _vm._s(_vm.formatDate(album.createdDate))
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "album-item-teacher" }, [
                        _c("i", { staticClass: "el-icon-user" }),
                        _vm._v(" Người đăng: "),
                        _c("b", [
                          _vm._v(_vm._s(album.createdBy || "Không rõ")),
                        ]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "album-item-foot" },
                        [
                          _c("span"),
                          !album.approved
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "success",
                                    size: "mini",
                                    icon: "el-icon-check",
                                    loading: _vm.approvingIdx === album.idx,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.approveAlbum(album)
                                    },
                                  },
                                },
                                [_vm._v("Duyệt ngay")]
                              )
                            : _c(
                                "router-link",
                                {
                                  staticClass: "view-photos-link",
                                  attrs: {
                                    to: `/album-v2/detail/${encodeURIComponent(
                                      album.idx
                                    )}`,
                                  },
                                },
                                [
                                  _vm._v(
                                    "Xem " + _vm._s(album.photoCount) + " ảnh"
                                  ),
                                ]
                              ),
                        ],
                        1
                      ),
                    ]),
                  ]
                )
              }),
            ],
            2
          ),
          _vm.detailTotal > _vm.detailSize
            ? _c(
                "div",
                { staticClass: "album-stat-pagination" },
                [
                  _c("el-pagination", {
                    attrs: {
                      layout: "prev, pager, next",
                      total: _vm.detailTotal,
                      "page-size": _vm.detailSize,
                      "current-page": _vm.detailPage + 1,
                    },
                    on: { "current-change": _vm.changeDetailPage },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("Đóng")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header-title-group" }, [
      _c("div", { staticClass: "header-icon-badge" }, [
        _c("i", { staticClass: "el-icon-picture-outline" }),
      ]),
      _c("div", [
        _c("h2", { staticClass: "header-title" }, [
          _vm._v("Thống Kê Album Hoạt Động & Ảnh Học Sinh"),
        ]),
        _c("p", { staticClass: "header-subtitle" }, [
          _vm._v("Album tạo trong kỳ; trạng thái duyệt tại thời điểm xem"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "chip-label" }, [
      _c("i", { staticClass: "el-icon-collection-tag" }),
      _vm._v(" Khối:"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "kpi-icon-wrap bg-purple-soft text-purple" },
      [_c("i", { staticClass: "el-icon-picture" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "kpi-title-row" }, [
      _c("span", { staticClass: "kpi-name" }, [
        _vm._v("Tổng album của trường"),
      ]),
      _c("span", { staticClass: "click-hint-badge text-purple" }, [
        _vm._v("Chi tiết "),
        _c("i", { staticClass: "el-icon-arrow-right" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "kpi-icon-wrap bg-emerald-soft text-emerald" },
      [_c("i", { staticClass: "el-icon-circle-check" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "kpi-title-row" }, [
      _c("span", { staticClass: "kpi-name" }, [_vm._v("Album đã được duyệt")]),
      _c("span", { staticClass: "click-hint-badge text-emerald" }, [
        _vm._v("Chi tiết "),
        _c("i", { staticClass: "el-icon-arrow-right" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "kpi-icon-wrap bg-amber-soft text-amber" },
      [_c("i", { staticClass: "el-icon-warning-outline" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "kpi-title-row" }, [
      _c("span", { staticClass: "kpi-name" }, [_vm._v("Album chờ duyệt")]),
      _c("span", { staticClass: "click-hint-badge text-amber" }, [
        _vm._v("Cần duyệt "),
        _c("i", { staticClass: "el-icon-arrow-right" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }